import cx from 'classnames'
import dayjs, { Dayjs } from 'dayjs'
import { Button } from 'blaze-ui/Button'
import Styles from './CancelSuccess.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Modal } from 'almanac-ui/Modal'

export type CancelSuccessFlowType = 'cancelSubscription' | 'deleteAccount' | 'deleteWorkspace'

interface Props {
  onClose: () => void
  onBack?: () => void
  subscriptionEndDate: Dayjs
  isAutopilotUser: boolean
  flowType: CancelSuccessFlowType
}

export const CancelSuccess = ({ onClose, onBack, subscriptionEndDate, isAutopilotUser, flowType }: Props) => {
  const isAutopilotStillActive = isAutopilotUser && dayjs(subscriptionEndDate).isAfter(dayjs())
  const formattedDate = subscriptionEndDate.format('MMM D, YYYY')

  const getHeaderTitle = () => {
    if (isAutopilotStillActive) {
      return 'Subscription canceled'
    }

    const titles: Record<CancelSuccessFlowType, string> = {
      deleteAccount: 'Account deleted',
      deleteWorkspace: 'Workspace deleted',
      cancelSubscription: 'Subscription canceled',
    }

    return titles[flowType]
  }

  const getHeading = () => {
    if (isAutopilotStillActive) {
      return `Your subscription has been canceled. Autopilot remains active until ${formattedDate}.`
    }
    return "We're sorry to see you go."
  }

  const getBody = () => {
    if (isAutopilotStillActive) {
      return `Your content will continue to automatically publish until ${formattedDate}. After that, no new content will be generated or published.`
    }
    if (flowType === 'deleteAccount') {
      return 'Your account is deleted, and your subscription has been canceled.'
    }
    if (flowType === 'deleteWorkspace') {
      return 'Your workspace is deleted, and your subscription has been canceled.'
    }
    return 'Your subscription has been canceled.'
  }

  const showBackButton = isAutopilotStillActive && !!onBack

  return (
    <div>
      <Modal.Header title={getHeaderTitle()} onClose={onClose} />
      <div className={Styles.header}>
        <Heading level={2} color="var(--dark-80)">
          {getHeading()}
        </Heading>
      </div>
      <div className={Styles.content}>
        <Text variant="primary" color="var(--dark-80)">
          {getBody()}
        </Text>
      </div>
      <div className={Styles.divider} />
      <div className={cx(Styles.footer, { [Styles.footerWithBack]: showBackButton })}>
        {showBackButton && (
          <Button className={Styles.backButton} variant="tertiary" size="lg" onPress={onBack}>
            Back
          </Button>
        )}
        <Button size="lg" onPress={onClose}>
          Close
        </Button>
      </div>
    </div>
  )
}
